import { Box, Tooltip, Typography } from "@mui/material";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import { useTranslation } from "@localization/useTranslation";
import { AiChatAttachment } from "../AiChat.types";

interface AiChatAttachmentPillProps {
    attachment: AiChatAttachment;
    onPreview: (attachment: AiChatAttachment) => void;
}

function AiChatAttachmentPill({ attachment, onPreview }: AiChatAttachmentPillProps) {
    const { translateString } = useTranslation();

    return (
        <Tooltip title={translateString("aiChatViewAttachment")} arrow>
            <Box
                component="button"
                onClick={() => onPreview(attachment)}
                aria-label={translateString("aiChatViewAttachment")}
                sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 0.375,
                    paddingX: 0.75,
                    paddingY: 0.25,
                    borderRadius: 16,
                    border: "1px solid rgba(255, 255, 255, 0.3)",
                    backgroundColor: "rgba(255, 255, 255, 0.18)",
                    color: "inherit",
                    cursor: "pointer",
                    fontFamily: "inherit",
                    "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.28)" },
                }}
            >
                <InsertDriveFileOutlinedIcon sx={(theme) => ({ fontSize: 14, color: "inherit", fill: theme.customPalette.white })} />
                <Typography
                    component="span"
                    sx={{
                        fontSize: 11,
                        color: "inherit",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        maxWidth: 140,
                    }}
                >
                    {attachment.fileName}
                </Typography>
                <Typography component="span" sx={{ fontSize: 10, color: "inherit", opacity: 0.75, whiteSpace: "nowrap" }}>
                    {formatFileSize(attachment.fileSize)}
                </Typography>
            </Box>
        </Tooltip>
    );
}

function formatFileSize(bytes: number): string {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export default AiChatAttachmentPill;
